import { render, staticRenderFns } from "./PcCipRiskChip.vue?vue&type=template&id=eb4245ec&scoped=true"
import script from "./PcCipRiskChip.vue?vue&type=script&lang=js"
export * from "./PcCipRiskChip.vue?vue&type=script&lang=js"
import style0 from "./PcCipRiskChip.vue?vue&type=style&index=0&id=eb4245ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4245ec",
  null
  
)

export default component.exports